<template>
    <div class="modal-backdrop">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">编辑银行卡</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="editForm" :rules="rules" ref="editForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="银行名称" required prop="bankName">
                                    <el-input v-model="editForm.bankName" placeholder="请输入银行名称"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="银行支行名称" required prop="bankBranch">
                                    <el-input v-model="editForm.bankBranch" placeholder="请输入银行支行名称"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="银行卡号" required prop="bankNumber">
                                    <el-input v-model="editForm.bankNumber" placeholder="请输入银行卡号"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="银行卡状态" required>
                                    <el-select v-model="editForm.status" placeholder="选择银行卡状态" @change="changeStatus" style="width: 100%">
                                        <el-option
                                            v-for="item in status2"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-form>


            </div>
            <div class="modal-footer">
                 <el-button :loading="loading" type="primary" @click="confirm('editForm')">编辑</el-button>
            </div>
        </div>

    </div>
</template>


<script>

    import {getStaffCode} from "@/utils/auth";
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    export default {
        name: 'Add',
        props: ['roleValue'],
        data() {
            return {

                loading: false,

                editForm:{
                    timeStr:timeStr,
                    staffCode:getStaffCode(),
                    sign:'',
                    businessBankCode:'',
                    status:0,
                    bankName:'',
                    bankBranch:'',
                    bankNumber:'',
                },
                status2: [ {
                value: 1,
                label: '正常'
              },
                {
                  value: 2,
                  label: '禁用'
                }
              ],
                 rules:{
                    bankName:[
                        { required: true, message: '请输入银行名称', trigger: 'blur' },
                    ],
                    bankBranch:[
                        { required: true, message: '请输入银行支行名称', trigger: 'blur' },
                    ],
                    bankNumber:[
                        { required: true, message: '请输入银行卡号', trigger: 'blur' },
                    ]
                },
            }
        },
        methods: {
            init(row){
               this.$refs.editForm.resetFields();
                this.editForm.bankName = row.bankName;
                this.editForm.bankBranch = row.bankBranch;
                this.editForm.bankNumber = row.bankNumber;
                this.editForm.status = row.status;
                this.editForm.businessBankCode = row.businessBankCode;
            },
            closeSelf() {
                this.$emit("closeEdit");
            },
            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        return false;
                    }
                })
            },

            addSubmit(){
                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }
                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"BusinessBank/Edit",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },




        }
    }
</script>


<style>
    .modal-backdrop {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10;
    }
    .modal {
        background-color: #fff;
            box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        overflow-x:auto;
        display: flex;
        flex-direction: column;
        border-radius: 10px;
        width: 520px;
    }
    .modal-header {
        border-bottom: 1px solid #eee;
        color: #313131;
        justify-content: space-between;
        padding: 10px;
        display: flex;
    }
    .modal-footer {
        border-top: 1px solid #eee;
        justify-content: flex-end;
        padding: 15px;
        display: flex;
    }
    .modal-body {
        position: relative;
        padding: 20px 0px;
        z-index: 99;
    }
    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }

</style>
